module.exports = "<div class=\"tabbable\">\n\t<ul class=\"nav nav-tabs {{class}}\">\n\t\t<li *ngFor=\"let tab of tabs; let i = index;\" [ngClass]=\"{'in active': i == 0}\">\n\t\t\t<a data-toggle=\"tab\" href=\"#{{tab.tabId}}\">\n\t\t\t\t{{tab.name}}\n\t\t\t</a>\n\t\t</li>\n\t</ul>\n\n\t<div class=\"tab-content\">\n\t\t<ng-content></ng-content>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/tab/tab.html
// module id = 543
// module chunks = 0